import {
  DELETE_PAYMENT_FROM_MODAL,
  SUBMIT_PAYMENT_FORM,
} from "constants/actionTypes";
import { PaymentMethod } from "constants/payments";

export interface PromptDeleteAction {
  type: typeof DELETE_PAYMENT_FROM_MODAL.ACTION;
  paymentId: string;
}

export function promptDeletePaymentFromModal(
  paymentId: string,
): PromptDeleteAction {
  return {
    type: DELETE_PAYMENT_FROM_MODAL.ACTION,
    paymentId,
  };
}

export interface DeleteConfirmedAction {
  type: typeof DELETE_PAYMENT_FROM_MODAL.REQUEST;
  paymentId: string;
  resetToSold?: boolean;
}

export function deletePaymentFromModalConfirmed(
  paymentId: string,
  resetToSold?: boolean,
): DeleteConfirmedAction {
  return {
    type: DELETE_PAYMENT_FROM_MODAL.REQUEST,
    paymentId,
    resetToSold,
  };
}

export interface PaymentFormValues {
  id: string;
  fromBusinessId: string;
  toBusinessId: string;
  paymentMethod: PaymentMethod;
  totalAmountCents: number;
  paymentDate: string;
  paymentRef: string;
  notes: string;
  billingDocumentId?: string | null;
}

export interface SubmitFormAction {
  type: typeof SUBMIT_PAYMENT_FORM;
  values: PaymentFormValues;
  isNew: boolean;
}
export function submitPaymentForm(
  values: PaymentFormValues,
  isNew: boolean,
): SubmitFormAction {
  return {
    type: SUBMIT_PAYMENT_FORM,
    values,
    isNew,
  };
}
